import { GET_WSPOSITIONS, GET_WSPOSITIONS_SUCCESS, GET_WSPOSITIONS_ERROR} from './actionTypes';

const initialState = {
    errorGetWsPositions: "",
    loadingGetWsPositions: false,
    ws_positions: null,
    successWs: ""
}

const getWsPositions = (state = initialState, action) => {
    switch (action.type) {
        case GET_WSPOSITIONS:
            state = {
                ...state,
                loadingGetWsPositions: true
            }
            break;
        case GET_WSPOSITIONS_SUCCESS:
            state = {
                ...state,
                loadingGetWsPositions: false,
                ws_positions: action.payload.ws_positions, 
                successWs: action.payload.message
            }
            break;
        case GET_WSPOSITIONS_ERROR:
            state = { ...state, errorGetWsPositions: action.payload, loadingGetWsPositions: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getWsPositions;